import { Box } from "@material-ui/core";
import { generateAvatar, SelectedProject } from "api";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RoutesUrl } from "../../common/consts/Routes";
import { find, findAndUpdate, getData, store } from "../../services/service";
import CardComponent from "../shared/CardComponent";
import FormComponent, { FormData } from "../shared/test";

function NewAvatar() {
    let { id }: any = useParams();
    const { push } = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [formData, setFormData] = useState<FormData>({
        dynamicRows: [] as any,
    });
    const [parametrics, setParametrics] = useState<SelectedProject[]>([]);

    useEffect(() => {
        getData("data").then((parametrics: any) => {
            if (parametrics.length > 0) {
                setParametrics(parametrics);
            }
        });
        if (id) {

            setIsLoading(true);
            find("avatars", id)
                .then((val) => {
                    if (!!!val?.dynamicRows) {
                        val['dynamicRows'] = [];
                    }
                    // console.log("id", val);
                    setFormData(val);
                })
                .finally(() => setIsLoading(false));
        } else {
            setFormData({
                dynamicRows: [] as any,
            });
        }
    }, [id]);


    useEffect(() => {
        const clientName = parametrics.find((el: { [x: string]: any; }) => el?.['project'] === formData?.project)?.['choose-client'] || "";
        if (!id) {
            setFormData({ project: formData?.project, client: clientName, dynamicRows: [] as any });
        } else {
            setFormData((prev) => { return { ...prev, client: clientName } });
        }
    }, [formData?.project, id])
    const projects = parametrics.map((el: { [x: string]: any; }) => el?.['project']);

    return (
        <Box>
            <CardComponent title={`New Avatar`} isLoading={isLoading}>
                <FormComponent
                    staticFields={[
                        {
                            name: "project",
                            label: "Проект",
                            type: "autocomplete",
                            options: projects,
                            required: true,
                            /*************  ✨ Codeium Command ⭐  *************/
                            /**
                             * Checks if the given value is truthy.
                             * If it's not, returns an error message.
                             * @param {string} v The value to be validated.
                             * @returns {string | undefined} The error message if the value is falsy, undefined otherwise.
                             */
                            /******  00bd1da8-8968-4c7f-b630-c06674302119  *******/
                            validation: (v) => {
                                if (!v) {
                                    return "Полето е задължително!";
                                }
                            },
                        },
                        { name: "client", label: "Име на клиент", type: "text", required: true, disabled: true },
                        { name: "data", label: "Демографски данни", type: "text", required: true, textFieldProps: { multiline: true, inputProps: { maxLength: 500 } } },
                        { name: "interests", label: "Интереси и хобита", type: "text", required: true, textFieldProps: { multiline: true, inputProps: { maxLength: 500 } } },
                        { name: "profile", label: "Психологически профил", type: "text", required: true, textFieldProps: { multiline: true, inputProps: { maxLength: 500 } } },
                        { name: "values", label: "Ценности", type: "text", required: true, textFieldProps: { multiline: true, inputProps: { maxLength: 500 } } },
                        { name: "needs", label: "Потребности и проблеми", type: "text", required: true, textFieldProps: { multiline: true, inputProps: { maxLength: 500 } } },
                        { name: "behavior", label: "Поведение при покупка", type: "text", required: true, textFieldProps: { multiline: true, inputProps: { maxLength: 500 } } },
                        { name: "messages", label: "Ключови послания", type: "text", required: true, textFieldProps: { multiline: true, inputProps: { maxLength: 500 } } },
                        { name: "note", label: "Бележка", type: "text", required: false, textFieldProps: { multiline: true } },
                    ]}

                    onSubmit={async (data) => {
                        // TO DO:
                        // Important!
                        console.log("Submitted Data:", data); // Log submitted data

                        try {
                            if (id) {
                                await findAndUpdate("avatars", id, data);
                                toast.success("Успешно редактиране");
                                push(RoutesUrl.avatars.list);
                                return;
                            }
                            await store("avatars", data);
                            toast.success("Успешно добавяне");
                            push(RoutesUrl.avatars.list);
                            return true;
                        } catch (e) {
                            toast.error("Нещо се обърка");
                            console.error(e);
                            return false;
                        }
                    }}
                    editMode={id ? true : false}
                    formData={formData}
                    setFormData={setFormData}
                    // onGenerateAiData={async (data): Promise<void> => {
                    //     if (formData.project) {
                    //         const aiResponse = await generateAvatar(formData.project);
                    //         console.log(" ====== Martin log ->AI", aiResponse);
                    //         // implement AI
                    //         setFormData({ ...data, ...aiResponse });
                    //     } else {
                    //         alert("Моля, изберете проект!");
                    //     }
                    // }}
                    onGenerateAiData={async (data): Promise<void> => {
                        if (formData.project) {
                            setIsLoading(true);
                            const selectedProject = parametrics.find(p => p.project === formData.project);
                            if (!selectedProject) {
                                toast.error("Името на кампанията не е намерено!");
                                return;
                            }

                            try {
                                const aiResponse = await generateAvatar(selectedProject);
                                console.log("AI Response:", aiResponse);
                                if (Object.values(aiResponse).every(v => !v)) {
                                    toast.error("Не успяхме да генерираме данни!");
                                    return;
                                }
                                setFormData(prev => ({ ...prev, ...aiResponse }));
                            } catch (error) {
                                console.error("Generate error:", error);
                                toast.error("Грешка при генериране!");
                            }
                            setIsLoading(false);
                        } else {
                            toast.error("Моля, изберете име на кампанията!");
                        }
                    }}
                />
            </CardComponent>
        </Box>
    )
}

export default NewAvatar;